import { render, staticRenderFns } from "./data-preview.vue?vue&type=template&id=faf66188&"
import script from "./data-preview.vue?vue&type=script&lang=ts&"
export * from "./data-preview.vue?vue&type=script&lang=ts&"
import style0 from "./data-preview.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports